export default __webpack_public_path__ + "static/media/soundPack5.05b717ca.png";